import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { LiveChannelsDataService, LiveChannelsColumnsService } from '../../../services';
import { LiveChannel, LiveChannelsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-live-channel-details',
  templateUrl: './live-channel-details.component.html',
  styleUrls: ['./live-channel-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class LiveChannelDetailsComponent implements OnInit, OnDestroy {

  public liveChannel: LiveChannel = {};
  public liveChannels: LiveChannel[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private liveChannelsDataService: LiveChannelsDataService,
    private liveChannelsColumnsService: LiveChannelsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Live Channel - Details');
        this.getLiveChannel(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.liveChannel !== 'undefined') {
      this.liveChannel = this.dynamicDialogConfig.data.liveChannel;
    }
    this.columns = this.liveChannelsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getLiveChannel(id: number): void {
    this.isLoading = true;
    this.liveChannelsDataService.getLiveChannel(id).subscribe((response: LiveChannel|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.liveChannel = response;
      }
    });
  }

  list() {
    this.router.navigate(['/live-channels']);
  }

  add() {
    this.router.navigate(['/live-channels/add']);
  }

  edit() {
    this.router.navigate(['/live-channels/edit/' + this.liveChannel.id]);
  }

}
@Component({
  selector: 'app-live-channel-details',
  templateUrl: './live-channel-details.component.html',
  styleUrls: ['./live-channel-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogLiveChannelDetailsComponent extends LiveChannelDetailsComponent {
}

